import { useEffect, useState } from "react";

export const SEARCH_DEBOUNCE_MS = 700;
export const MIN_SEARCH_LENGTH = 2;

export const toApiSearchQuery = (value) => {
  const trimmed = String(value ?? "").trim();
  return trimmed.length >= MIN_SEARCH_LENGTH ? trimmed : "";
};

/**
 * Keeps typed input instant while API query updates only after debounce settles.
 * Clears API query immediately when input is emptied.
 */
export function useDebouncedSearchQuery(
  inputValue,
  debounceMs = SEARCH_DEBOUNCE_MS,
  minLength = MIN_SEARCH_LENGTH
) {
  const trimmedInput = String(inputValue ?? "").trim();
  const [apiSearchQuery, setApiSearchQuery] = useState("");
  const [isDebouncing, setIsDebouncing] = useState(false);

  useEffect(() => {
    if (!trimmedInput) {
      setApiSearchQuery("");
      setIsDebouncing(false);
      return undefined;
    }

    setIsDebouncing(true);

    const timer = window.setTimeout(() => {
      setApiSearchQuery(
        trimmedInput.length >= minLength ? trimmedInput : ""
      );
      setIsDebouncing(false);
    }, debounceMs);

    return () => window.clearTimeout(timer);
  }, [trimmedInput, debounceMs, minLength]);

  return { apiSearchQuery, isSearchPending: isDebouncing, trimmedInput };
}

export default useDebouncedSearchQuery;
